import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { isFacebookSDKLoadedAtom } from "../atoms/isFacebookSDKLoadedAtom";

const FACEBOOK_SCRIPT_ID = "facebook-jssdk";
const FACEBOOK_APP_ID = "1138725626624346";
const FACEBOOK_SCRIPT_URL = "https://connect.facebook.net/en_US/sdk.js";

export const useLoadFacebookSDK = () => {
  const setIsFacebookSDKLoaded = useSetAtom(isFacebookSDKLoadedAtom);

  useEffect(() => {
    window.fbAsyncInit = function () {
      FB.init({
        appId: FACEBOOK_APP_ID,
        xfbml: true,
        version: "v22.0",
        cookie: true,
      });

      setIsFacebookSDKLoaded(true);
    };

    const existingScript = document.getElementById(FACEBOOK_SCRIPT_ID);
    if (existingScript) {
      return;
    }
    const script = document.createElement("script");
    script.src = FACEBOOK_SCRIPT_URL;
    script.async = true;
    script.id = FACEBOOK_SCRIPT_ID;
    document.body.appendChild(script);
  }, [setIsFacebookSDKLoaded]);
};
